import { render } from "./PaqueteProductosList.vue?vue&type=template&id=6c975241&scoped=true"
import script from "./PaqueteProductosList.vue?vue&type=script&lang=js"
export * from "./PaqueteProductosList.vue?vue&type=script&lang=js"

import "./PaqueteProductosList.vue?vue&type=style&index=0&id=6c975241&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c975241"]])

export default __exports__